module.exports = __webpack_public_path__ + "img/szcc.c6f03970.png";